import { create } from 'zustand'
import { AppLevelStoreProps } from './storeTypes/appLevelStoreTypes'



const useAppLevelStores = create<AppLevelStoreProps>((set) => ({
  isLoading:false,
  setIsLoading:(data:boolean)=>set(()=>({isLoading:data})),
  isOpenCandidateAllotmentPopup:false,
   setIsOpenCandidateAllotmentPopup:(data:boolean)=>set(()=>({isOpenCandidateAllotmentPopup:data})),
   noCreditFlag:false,
   setNoCreditFlag:(data:boolean)=>set(()=>({noCreditFlag:data})),
   showResultRegenrateFlag:false,
   setShowResultRegenarateFlag:(data:boolean)=>set(()=>({showResultRegenrateFlag:data})),
   openCreditDialog:false,
   setIsOpenCreditDialog:(data:boolean)=>set(()=>({openCreditDialog:data})),
   loadingMessage:"Loading Please wait",
   setLoadingMessage:(data:string)=>set(()=>({loadingMessage:data})),
   expandedMenu:[""],
   setExpandedMenu:(data:Array<string>)=>set(()=>({expandedMenu:data})),
   resetAppLevelContext:()=>set(()=>({isLoading:false,loadingMessage:""}))
}))

export default useAppLevelStores